// features/drive/components/Search/Search.js

import React from 'react';
import { Search as SearchIcon } from 'lucide-react';

import useDrive from '../../hooks/useDrive';

import { SearchWrapper, SearchInput, SearchIconWrapper } from './Search.styles';

const Search = () => {
  const { search, setSearch } = useDrive();

  return (
    <SearchWrapper>
      <SearchIconWrapper>
        <SearchIcon size={16} />
      </SearchIconWrapper>

      <SearchInput
        placeholder="Search files and folders..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </SearchWrapper>
  );
};

export default Search;
